import './styles.scss';

import React from 'react';

interface AppSpinnerProps {
    text?: string;
}

export const AppSpinner = ({text = ''}: AppSpinnerProps) => {
    return (
        <div className='app-spinner'>
            {!!text && text + ' '}
            <div className='app-spinner__item bounce1'></div>
            <div className='app-spinner__item bounce2'></div>
            <div className='app-spinner__item bounce3'></div>
        </div>
    );
};
